import { useQuery } from "@tanstack/react-query"
import { FileGet } from "../app/models/File"
import { digitalManagerApi } from "../services/api"

export function useFiles(getPublic = false) {
  const { data: files = [], isLoading: isLoadingFiles } = useQuery({
    queryKey: ["files", getPublic],
    queryFn: () =>
      digitalManagerApi
        .get<FileGet[]>("/files", { params: { getPublic } })
        .then((r) => r.data),
  })

  return {
    files,
    isLoadingFiles,
  }
}
